"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactHorizontalScrollingMenu = require("react-horizontal-scrolling-menu");
require("./globalStyles.css");
var _styles = require("./styles");
var _useDrag = _interopRequireDefault(require("./useDrag"));
var _index = require("./index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Tab = ({
  selected,
  onClick,
  title
}) => {
  const visibility = _react.default.useContext(_reactHorizontalScrollingMenu.VisibilityContext);
  return _react.default.createElement(_styles.MobileTab, {
    selected: selected,
    onClick: () => onClick(visibility),
    role: "button",
    tabIndex: 0
  }, _react.default.createElement("span", null, title));
};
function MobileTabs({
  sections
}) {
  const {
    dragStart,
    dragStop,
    dragMove,
    dragging
  } = (0, _useDrag.default)();
  const {
    current,
    scrollToSection
  } = (0, _react.useContext)(_index.TabsContext);
  const apiRef = (0, _react.useRef)(null);
  const handleDrag = ({
    scrollContainer
  }) => ev => dragMove(ev, posDiff => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollLeft += posDiff;
    }
  });
  const handleItemClick = itemId => ({
    getItemById,
    scrollToItem
  }) => {
    if (dragging) {
      return false;
    }
    scrollToSection(itemId);
    scrollToItem(getItemById(itemId), 'smooth', 'center', 'nearest');
  };
  (0, _react.useEffect)(() => {
    if (sections[current]) {
      setTimeout(() => {
        apiRef.current.scrollToItem(apiRef.current.getItemById(sections[current].id), 'smooth', 'center', 'nearest');
      }, 100);
    }
  }, [current]);
  return _react.default.createElement(_styles.MobileTabsWrapper, {
    onMouseLeave: dragStop
  }, _react.default.createElement(_reactHorizontalScrollingMenu.ScrollMenu, {
    apiRef: apiRef,
    onWheel: onWheel,
    onMouseDown: () => dragStart,
    onMouseUp: ({
      getItemById,
      scrollToItem,
      visibleItems
    }) => () => {
      dragStop();
      const {
        center
      } = (0, _reactHorizontalScrollingMenu.getItemsPos)(visibleItems);
      scrollToItem(getItemById(center), 'smooth', 'center');
    },
    options: {
      throttle: 0
    },
    onMouseMove: handleDrag
  }, sections.map(({
    id,
    displayName
  }, index) => {
    return _react.default.createElement(Tab, {
      title: displayName,
      itemId: id,
      key: id,
      onClick: handleItemClick(id),
      selected: current === index
    });
  })));
}
var _default = MobileTabs;
exports.default = _default;
function onWheel({
  getItemById,
  items,
  visibleItems,
  scrollToItem
}, ev) {
  const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;
  if (isThouchpad) {
    ev.stopPropagation();
    return;
  }
  if (ev.deltaY < 0) {
    const nextGroupItems = (0, _reactHorizontalScrollingMenu.slidingWindow)(items.toItemsKeys(), visibleItems).next();
    const {
      center
    } = (0, _reactHorizontalScrollingMenu.getItemsPos)(nextGroupItems);
    scrollToItem(getItemById(center), 'smooth', 'center');
  } else if (ev.deltaY > 0) {
    const prevGroupItems = (0, _reactHorizontalScrollingMenu.slidingWindow)(items.toItemsKeys(), visibleItems).prev();
    const {
      center
    } = (0, _reactHorizontalScrollingMenu.getItemsPos)(prevGroupItems);
    scrollToItem(getItemById(center), 'smooth', 'center');
  }
}
//# sourceMappingURL=mobile.js.map